require('./lbaPerDiemGridItem.scss');
const $inject = [];
const lbaPerDiemGridItem = function () {
  return {
    restrict: 'A',
    scope: {
      settings: '<'
    },
    bindToController: true,
    controller: 'lbaPerDiemGridItemCtrl',
    controllerAs: 'vm',
    template: require('./lbaPerDiemGridItem.html')
  }
};

lbaPerDiemGridItem.$inject = $inject;

export default lbaPerDiemGridItem;


// WEBPACK FOOTER //
// ./src/components/lbaPerdiemGridItem/lbaPerDiemGridItemDir.js